import { createContext } from 'react'
import type { Provider } from '@/types/provider'
import type { RegisterProviderData } from '@/lib/api'

export interface ProviderAuthContextType {
  provider: Provider | null
  login: (emailOrUsername: string, password: string) => Promise<void>
  register: (data: RegisterProviderData) => Promise<void>
  logout: () => Promise<void>
  refreshProvider: () => Promise<void>
  isLoading: boolean
  isAuthenticated: boolean
}

export const ProviderAuthContext = createContext<ProviderAuthContextType | null>(null)
